import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AgGridReact } from 'ag-grid-react'
import s from './ReportsGrid.scss'
import * as ACT from '../actions'
import { fromReportGridExtended } from '../serializers'
import { TableContainer } from 'components/ideal-core-ui'
import { currencyFormatter, percentageFormatter } from 'utils/helpers'

const ReportsGridContainer = () => {
  const columnDefs = [
    {
      headerName: 'Due Date',
      field: 'dueDate'
    },
    {
      headerName: 'Opportunity Name',
      field: 'name',
      cellClass: 'deals-name-column'
    },
    {
      headerName: 'Client',
      field: 'companyName'
    },
    {
      headerName: 'Brief Note',
      field: 'briefNote'
    },
    {
      headerName: 'Internal Bid Status',
      field: 'newBidReview'
    },
    {
      headerName: 'Client Bid Stage',
      field: 'biddingAwarded'
    },
    {
      headerName: 'Awarded To',
      field: 'awardedCompany'
    },
    {
      headerName: 'Proposal Status',
      field: 'status'
    },
    {
      headerName: 'Follow Up Date',
      field: 'followUpDate'
    },
    {
      headerName: 'Sent To',
      field: 'sentTo'
    },
    {
      headerName: 'Main Contact',
      field: 'mainContact'
    },
    {
      headerName: 'Main Contact Phone',
      field: 'mainContactPhone'
    },
    {
      headerName: 'Main Contact Email',
      field: 'mainContactEmail'
    },
    {
      headerName: 'Opportunity Manager',
      field: 'dealManager'
    },
    {
      headerName: 'Opportunity Category',
      field: 'dealCategory',
      valueFormatter: params => {
        return params && params.value ? params.value.name : ''
      }
    },
    {
      headerName: 'Opportunity Size',
      field: 'dealSize'
    },
    {
      headerName: 'Value',
      field: 'value',
      valueFormatter: currencyFormatter
    },
    {
      headerName: 'Cost',
      field: 'cost',
      valueFormatter: currencyFormatter
    },
    {
      headerName: 'Margin',
      field: 'margin',
      valueFormatter: percentageFormatter
    },
    {
      headerName: 'Profit',
      field: 'profit',
      valueFormatter: currencyFormatter
    },
    {
      headerName: 'Won Date',
      field: 'wonDate'
    },
    {
      headerName: 'Close Date',
      field: 'closeDate'
    },
    {
      headerName: 'Opportunity Status',
      field: 'dealStatus'
    },
    {
      headerName: 'Quote Number',
      field: 'quoteNumber'
    },
    {
      headerName: 'Project Number',
      field: 'projectNumber'
    }
  ]

  const dispatch = useDispatch()
  const reportsBidFollowUp = useSelector(state => state.lists.reportsBidFollowUp)

  useEffect(() => {
    dispatch({ type: ACT.BID_FOLLOW_UP_FETCH_REQUESTED })
  }, [dispatch])

  return (
    <>
      <TableContainer className={s.grid} canSaveAsList tableKey="lists">
        {gridData => (
          <AgGridReact
            {...gridData}
            columnDefs={columnDefs}
            rowData={fromReportGridExtended(reportsBidFollowUp)}
          />
        )}
      </TableContainer>
    </>
  )
}

export default ReportsGridContainer
